import styled from "styled-components"

export const Wrapper = styled.div`
    overflow: hidden;
    > .column + .column {
        border-top: 0;
    }
`
